import { useAuth } from "../context/AuthContext";

export const useSession = () => {
    const { user, status, isAuthenticated, initSession } = useAuth();

    return {
        user,
        isAuthenticated,
        isLoading: status === "initializing",
        status,
        initSession,
    };
};